import { config } from "../configs/config";
import { h } from "@/app/helpers";
import Axios from "axios";

export async function getTokens(params, showMessage = false) {
    const response = await Axios({
        url: `${config.apiUrl}/v1/app/profile/tokens`,
        method: "get",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        params,
    });
    return h.api.handleApiResponse(response, showMessage);
}

export async function getProfile(data, showMessage = false) {
    const response = await Axios({
        url: `${config.apiUrl}/v1/app/profile/me`,
        method: "get",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        data,
    });
    return h.api.handleApiResponse(response, showMessage);
}

export async function updateProfile(data, showMessage = false) {
    const response = await Axios({
        url: `${config.apiUrl}/v1/app/profile/me`,
        method: "put",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        data,
    });
    return h.api.handleApiResponse(response, showMessage);
}
